import { BasketCartFeeSummaryUrl, CartProfileUpdateUrl,BasketCartUrl, DeclarationCandidacyUrl, MyAccountUrl, OrderDuplicateCertificateUrl, OrderVerificationEnrollmentUrl } from "../directives/utilities/urls";
export default function basketCartList() {
    return {
        selectedItem:[],
        showErrorMesage: "",
        successMessage: "",
        enrollmentCartList: [],
        basketTotal:0,
        hasMore: false,
        isSubmitting: false,
        headingName:'Cart',
        showLoader: false,
        backPageUrl:DeclarationCandidacyUrl,
        editCartList(item) {         
            if (item.saleType == 4) {
                window.location.href = OrderDuplicateCertificateUrl+"?e=" + item.basketId;
            }
            else if (item.saleType == 5) {
                window.location.href = OrderVerificationEnrollmentUrl+"?e=" + item.basketId;
            }
        },

        showRemoveCartList(item) {
            this.selectedItem = item;
            document.getElementById("btnDelete").click();
        },
        removeCartList(item) {
                var jsonData = JSON.stringify({
                    "BasketId": this.selectedItem.basketId.toString()
                });

                this.showLoader = true;

                fetch("/api/Basket/delete-declare-candidacy", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.showSuccessMesage = "Course removed succesfully."
                            window.location.href = BasketCartUrl;
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
        },
        nextStep() {
            this.isSubmitting = true;
            //document.location.href = BasketCartFeeSummaryUrl;
            document.location.href = CartProfileUpdateUrl;
        },
        cancelBasketClick() {       
            if (confirm("Are you sure you want to cancel this request?")) {
                this.showLoader = true;
                fetch("/api/Basket/cancel-declare-candidacy", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                   
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            window.location.href = MyAccountUrl;
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
            }

        },
        bindBasketList() {          
            this.showLoader = true;
            this.enrollmentCartList = [];
            fetch("/api/Basket/GetBasketList", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
               
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
 
                        if (response.basketList.length > 0) {
                         
                            if (response.basketList[0].saleType == 1) {
                                this.backPageUrl = DeclarationCandidacyUrl;
                            }
                            else if (response.basketList[0].saleType == 4) {
                                this.backPageUrl = OrderDuplicateCertificateUrl;
                            }
                            else if (response.basketList[0].saleType == 5) {
                                this.backPageUrl = OrderVerificationEnrollmentUrl;
                            }

                            this.basketTotal = response.basketTotal;
                          

                            if (response.basketList[0].saleType == 3) {
                                this.headingName = "Balance Cart";
                            } else {
                                this.headingName = response.basketList[0].saleType == 1 ? response.basketList[0].description : response.basketList[0].name;
                            }
                            
                            Array.prototype.push.apply(this.enrollmentCartList, response.basketList);
                        } else {
                            window.location.href =MyAccountUrl;
                        }
                    } else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },
        init() {
            this.bindBasketList();
        },
    };
}
